import React from 'react';

export class Footer extends React.Component {
    render(){
        
        return (
            <footer className="footer home-footer">
                <div className="footer-head">
                    <div className="container">
                        <div className="columns is-multiline is-mobile">
                            <div className="column is-2-desktop is-12-mobile">
                            </div>
                            <div className="column is-2-desktop is-12-mobile border-right">
                            © Copyright 2019 HWG Cash
                            </div>
                            
                        </div>
                    </div>
                    </div>
            </footer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_components/Footer.jsx